"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class EmployeeSearchResponse extends common_1.PaginatedResponse {
}
exports.EmployeeSearchResponse = EmployeeSearchResponse;
//# sourceMappingURL=employee-search.response.js.map